<template>
  <div>
    <!--应用软件分类，动态路由-->
    <div class="wholePage" v-show="!showDtl">
      <div class="topBar">
        <el-input
          v-model="keyWords"
          class="search"
          placeholder="请输入"
          clearable
          @clear="getSortAppList"
          @keyup.enter.native="getSortAppList">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="getSortAppList"></i>
        </el-input>

        <span class="title">支持设备类型</span>
        <el-select
          v-model="dvcType"
          filterable
          clearable
          @change="getSortAppList"
        >
          <el-option
            v-for="item in dvcTypeList"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="appList">
        <div class="cardApp" v-for="(item, index) in appList" :key="'app'+index" @click="gotoAppDetails(item)">
          <div class="appImg">
            <img :src="item.imsUrl" width="110px" height="110px" class="imgCenter">
          </div>
          <div class="appTitle" :title="item.applyName">
            {{item.applyName}}
          </div>
        </div>
      </div>
      <div v-if="appList.length > 0">
        <el-pagination
          style="text-align: center; margin-top: 20px;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[50]"
          :page-size="pageSize"
          layout="total,sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <div v-else class="noData">
        暂无数据
      </div>
    </div>
    <!--详情页-->
    <div v-show="showDtl" style="min-width: 1630px;">
      <appDetails :appInfo="appInfo" @return="returnToAppHome" @update="initPageData"></appDetails>
    </div>
  </div>
</template>

<script>
  import { getSortApp } from "../../../api/appStore/sortApp";
  import {selectDevicetypeList} from "../../../api/appStore/appCommon";
  import appDetails from "./appDetails";

  export default {
    name: "sortApp",
    components: {
      appDetails
    },
    data(){
      return {
        id: '', // 分类id
        keyWords: '',
        dvcType: '',
        dvcTypeList: [],

        appList: [],

        // 分页器相关
        currentPage: 1,
        pageSize: 50,
        total: 0,

        // 跟应用软件详情相关的
        showDtl: false,
        // 单个app的详细数据
        appInfo: null,
      }
    },
    methods: {
      // 进入详情页
      gotoAppDetails(item) {
        this.appInfo = item;
        this.showDtl = true;
      },
      // 返回首页
      returnToAppHome() {
        this.appInfo = null;
        this.showDtl = false;
      },
      // 切换分页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getSortAppList();
      },
      // 切换单页大小
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getSortAppList();
      },
      // 从路由中获取参数
      getPageDtl(params) {
        this.id = params.id;
      },
      // 获取支持设备类型列表
     async getDvcTypeList() {
       await selectDevicetypeList().then(res => {
          if (res.returnCode === '100') {
            let dataArr = res.returnData;
            let resArr = [];
            for (let i = 0; i < dataArr.length; i++) {
              let item = {
                label: dataArr[i].devicetypeName,
                value: dataArr[i].id+''
              };
              resArr.push(item);
            };
            this.dvcTypeList = resArr;
          }
        }).catch(e => e);
      },
      // 获取分类应用软件分页列表
      async getSortAppList() {
        this.showLoading1 = true;
        await getSortApp({
          applytypeId: parseInt(this.id),
          applyName: this.keyWords,
          deviceTypeId: this.dvcType,
          curPage: this.currentPage,
          pageSize: this.pageSize
        }).then(res => {
          this.appList = res.returnData.applys;
          this.total = res.returnData.count ? res.returnData.count : 0;
        }).catch(e => e);
        this.showLoading1 = false;
      },
      async initPageData() {
        await this.getDvcTypeList();
        await this.getSortAppList();
        this.showDtl = false;

      },
      // 应用分类的共用页面，切换时要清除筛选项
      clearFilter() {
        this.keyWords = '';
        this.dvcType = '';

      }
    },
    beforeRouteEnter(to, from, next){
      next(vm=>{
        vm.getPageDtl(to.params);
        vm.clearFilter();
        vm.initPageData();
      })
    },
    beforeRouteUpdate (to, from, next) {
      this.getPageDtl(to.params);
      this.clearFilter();
      this.initPageData();
      next()
    }
  }
</script>

<style scoped lang="less">
  .wholePage {
    font-size: 18px;
    text-align: left;
    min-height: 100vh;
    background-color: white;
    border: 1px solid #f0f0f0;
    border-radius: 5px;
    padding-top: 10px;
    padding-left: 10px;
  }

  .topBar {
    margin-bottom: 20px;
    .search {
      width: 200px;
      i {
        cursor: pointer;
      }
    }

    .title {
      display: inline-block;
      margin: 0 10px 0 20px;
    }
  }

  /*应用软件样式*/
  .cardApp {
    cursor: pointer;
    display: inline-block;
    text-align: center;
    margin: 0 20px;
    .appImg {
      width: 120px;
      height: 120px;
      /*border: 2px solid #008FE0;*/
      border: 1px solid #617799;
      border-radius: 10px;
      box-sizing: border-box;
      line-height: 116px; // 图裂放中间位置
      .imgCenter {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .appTitle {
      font-size: 16px;
      margin-top: 5px;
      width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .noData {
    text-align: center;
    font-size: 18px;
    padding-top: 40vh;
  }
</style>
